import { FC } from 'react';
import { Auth } from '@barracuda/shared';
import { useAppContext } from '@/context/App.context';
import { Button, SxProps, Theme } from '@mui/material';
import { useLocalizedNavigate } from '@/hooks/useLocalizedNavigate';
import { mixpanelApi } from '@barracuda/shared/analytics/mixpanel';
import { logoutButtonStyle } from './Logout.styles';

export const Logout: FC<{
  children: JSX.Element | JSX.Element[];
  sx?: SxProps<Theme>;
  onLogout?: () => void;
}> = ({ children, sx = logoutButtonStyle, onLogout }) => {
  const { user, setUser, setIsLoggedIn, setPurchaseBlockedReason } = useAppContext();
  const navigate = useLocalizedNavigate();

  const handleLogout = () => {
    mixpanelApi.onLogout();

    Auth.logout(user?.profile?.loggedBefore);
    setUser(undefined);
    setIsLoggedIn(false);
    setPurchaseBlockedReason?.(undefined);
    onLogout?.();
    navigate('/login');
  };

  return (
    <Button type='button' variant='text' onClick={handleLogout} sx={sx}>
      {children}
    </Button>
  );
};
